<template>
  <svg :height="height" :width="width" viewBox="0 0 500 550" xmlns="http://www.w3.org/2000/svg">
    <path fill="grey" xmlns="http://www.w3.org/2000/svg" d="M382.5,255c43.35,0,76.5-33.15,76.5-76.5S425.85,102,382.5,102S306,135.15,306,178.5S339.15,255,382.5,255z M178.5,255    c43.35,0,76.5-33.15,76.5-76.5S221.85,102,178.5,102S102,135.15,102,178.5S135.15,255,178.5,255z M178.5,306    C119.85,306,0,336.6,0,395.25V459h357v-63.75C357,336.6,237.15,306,178.5,306z M382.5,306c-7.65,0-15.3,0-25.5,2.55    c30.6,20.4,51,51,51,86.7V459h153v-63.75C561,336.6,441.15,306,382.5,306z"/>
  </svg>
</template>

<script>
export default {
  name: 'ShareWithUsersIcon',
  props: {
    height: {
      default: 30,
    },
    width: {
      default: 32,
    }
  }
}
</script>



// WEBPACK FOOTER //
// SharedWithUsersIcon.vue?956d7a4a